// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#analytics-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n#analytics-container mat-card {\n  width: 100%;\n  margin-top: 16px;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
